# F88 — Asset Instance list screen
# Route: /asset/instances
# Real Assets domain API (GET /api/asset/instances) — live-mutable runtime
# aggregates, distinct from the /asset/classes versioned-YAML editor.

page-config-asset-instance-list:
  type: Page
  archetype: list
  meta:
    title: $t.config_asset_instance.meta_title
    route: /asset/instances
    layout: shell
    auth: required
  data:
    instances:
      model: AssetInstance[]
      refresh: on_mount
      data_states:
        loading:
          skeleton_count: 6
        empty:
          ref: config-ai-list-empty
        error: default
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - config-ai-list-sm-notice
    - config-ai-list-content

config-ai-list-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_desktop

config-ai-list-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - config-ai-list-header
    - config-ai-list-table

config-ai-list-header:
  type: PageHeader
  content: $t.config_asset_instance.list_title
  actions:
    - label: $t.config_asset_instance.btn_create
      route: /asset/instances/new
      color: info
      return_context: origin_only

config-ai-list-table:
  type: Table
  bind:
    rows: instances
  empty: config-ai-list-empty
  # M1 list-filter adoption (DEC-090) — opt-in client-side quick-filter: this
  # list had no filter at all. Case- and accent-folded substring + native clear
  # over the loaded rows. The searched set is the flat string columns;
  # `location.level1` is not searched.
  filter:
    fields: [name, assetClassName, status]
    placeholder: $t.common.quick_filter
  columns:
    - key: name
      label: $t.config_asset_instance.col_name
      tokens:
        font_size: $font.size.sm
    # Resolved class display name (assetClassName, additive DTO field) — the
    # raw assetClassRef id read as "no class" to reviewers; the ref stays the
    # write-side identity and is visible on the editor page.
    - key: assetClassName
      label: $t.config_asset_instance.col_class
      tokens:
        font_size: $font.size.sm
    - key: location.level1
      label: $t.config_asset_instance.col_location
      tokens:
        font_size: $font.size.sm
    - key: status
      label: $t.config_asset_instance.col_status
      tokens:
        font_size: $font.size.sm
  row_action:
    type: navigate
    route: /asset/instances/:id
    params:
      id: $row.id
    return_context: list_state
  a11y:
    label: $t.config_asset_instance.table_label
  tokens:
    border: $border.default
    radius: $radius.md
    background: $color_scheme.light.color.surface-elevated

config-ai-list-empty:
  type: EmptyState
  content: $t.config_asset_instance.empty_title
  body: $t.config_asset_instance.empty_body
  cta_label: $t.config_asset_instance.btn_create
  cta_route: /asset/instances/new
  tokens:
    color: $color_scheme.light.color.on-surface-muted
    font_size: $font.size.md
  spatial:
    padding: $spacing.lg
